module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter1"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block4"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p10"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("T")]), _vm._v("eri Summers tore through the doorway of the Last Chance urgent care clinic, skidded over the polished floor, and sagged against the reception desk. Dana Foster looked up from her paperwork, a tiny angel pin glittering from her red cashmere sweater. The angel winked at Teri.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p11"
    }
  }, [_vm._v("Or maybe Teri was hallucinating because of hypoxia. She had just run all the way from Last Chance Bloomers—a distance of at least a mile. “Is Aiden all right?” She wheezed like a broken accordion.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p12"
    }
  }, [_vm._v("Dana gave her a benign smile and said, “It’s like I told you on the phone, Teri. It’s a minor injury. He’s in with Doc Crawford right now. Through the doors, the cubicle on the right.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p13"
    }
  }, [_vm._v("Teri took one step toward the double doors before Dana’s words registered. She stopped. Turned. “Doc Crawford?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p14"
    }
  }, [_vm._v("“The new doctor. He’s from "), _c('i', [_vm._v("Boston")]), _vm._v(".” Dana pronounced the name of the city with a broad “a” sound and rolled her eyes in a way that didn’t inspire confidence.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p15"
    }
  }, [_vm._v("“Where’s Doc Cooper?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p16"
    }
  }, [_vm._v("“He’s gone off to Florida to look for retirement property. He’ll be back after Christmas, but he’s retiring in February.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p17"
    }
  }, [_vm._v("Teri had just begun processing this news when an altogether familiar howl pierced the quiet of the waiting room. Oh boy. Disaster had struck, just as she’d feared. Aiden’s injury might be minor, but her son didn’t do well with doctors.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p18"
    }
  }, [_vm._v("She followed the screams to Aiden’s examination cubicle, where a big guy in a white coat blocked her way.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p19"
    }
  }, [_vm._v("Judy Cabello, Aiden’s after-school caregiver, stood facing the doctor explaining things while she wrung her hands the way the guilty do. When she said “Asperger’s spectrum,” she whispered the words as if Aiden carried the plague or something.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p20"
    }
  }, [_vm._v("Teri stifled the urge to join Aiden in a primal scream. Instead, she swallowed back her anger. It burned down her parched throat. “What happened?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p21"
    }
  }, [_vm._v("The doctor turned, and Judy said, “Oh, hi, Teri. I’m so sorry.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p22"
    }
  }, [_vm._v("“What happened?” she repeated.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p23"
    }
  }, [_vm._v("“Uh, well, we were outside searching for some pinecones to make a Christmas wreath. I turned away for just one minute, and Aiden went off climbing the woodpile. He was talking to his angel when he fell. He’s got a gigantic splinter in his thigh. He freaked out, and I didn’t know what else to do.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p24"
    }
  }, [_c('i', [_vm._v("You could have called me at the store instead of bringing him here and letting Dana scare me to death. ")]), _vm._v("But Teri didn’t say that out loud. Judy had tons of experience with special needs kids, just not kids like Aiden. Bringing Aiden to the doctor to have a splinter removed had to rate right up there with overreactions of the century. Aiden didn’t do doctor’s visits well.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p25"
    }
  }, [_vm._v("Teri turned toward the guy blocking the path to her son. He looked like he’d come directly from central casting for some medical TV show.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p26"
    }
  }, [_vm._v("“Excuse me,” she said as she stepped around him and finally saw Aiden’s injury. The word "), _c('i', [_vm._v("splinter")]), _vm._v(" didn’t give the three-inch shard of wood sticking out of Aiden’s thigh the respect it deserved. The calm facade she’d been trying to maintain melted. She wanted to fly to Aiden’s side and gather him up in the biggest mommy-hug ever. But Aiden didn’t like mommy-hugs.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p27"
    }
  }, [_vm._v("Aiden needed his angel.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p28"
    }
  }, [_vm._v("“Where’s Raphael?” Teri asked Judy.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p29"
    }
  }, [_vm._v("“I don’t know,” Judy replied. “It’s probably at home, or maybe lost in the woodpile. I didn’t take the time to look for it. I just brought him right here.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p30"
    }
  }, [_vm._v("Teri resisted the urge to criticize. Judy should have known not to leave Raphael at home. The resin figurine stood five inches high. Miriam Randall, a member of the Christ Church Ladies’ Auxiliary, had given it to Aiden two years ago, right after they had moved to Last Chance. The old lady had told her that Raphael was the angel of healing.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p31"
    }
  }, [_vm._v("Teri didn’t believe Aiden needed “healing.” He was the way he was and she loved him for himself. But the figurine had somehow become Aiden’s main comfort object. Without Raphael, she and Aiden were up a creek without a paddle, as the saying goes.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p32"
    }
  }, [_vm._v("“The injury isn’t as serious as it looks,” Dr. Crawford said, his voice deep and mellow as Tennessee whiskey, even if it did have a definite Yankee bite to it. “But I need him to stay still for a few minutes. If you can’t calm him down, we’ll have to sedate him.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p33"
    }
  }, [_vm._v("Not good. She hated sedating Aiden. He’d be groggy and out of sorts for days afterward. She had to do something to regain control. So she climbed up on the examining table beside Aiden, careful not to touch him. She bent over him and started singing “It Came Upon a Midnight Clear.” For once, the song was in season.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p34"
    }
  }, [_vm._v("She sang the carol a half dozen times while Aiden’s screams morphed into moans and then a definite hum, followed, finally, by his high, clear, boy soprano voice.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p35"
    }
  }, [_c('i', [_vm._v("Thank you, Lord.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p36"
    }
  }, [_vm._v("They sang the carol three or four more times, until Dr. Crawford cleared his throat and said, “We really need to deal with the splinter. Do you think white noise would help?” He took the stethoscope from around his neck, held it up, and gestured toward his ears.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p37"
    }
  }, [_vm._v("Bless him. He’d shown remarkable patience for the last five minutes. Doc Cooper would have given up a long time ago and gone looking for a hypodermic needle and a sedative.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p38"
    }
  }, [_vm._v("The new doc met her gaze, his brown eyes steady and reassuring. Oh boy, the new doc from “Bah-sten” was a class-A dreamboat. She gave the meddling church ladies of Last Chance a week before they started trying to find him his soul mate.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p39"
    }
  }, [_vm._v("She nodded in his direction and then got right up in Aiden’s face. “Aiden, Doctor Crawford needs to fix your hurt leg. Would you like to try his stethoscope?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p40"
    }
  }, [_vm._v("The doctor moved slowly so as not to startle Aiden. He dangled the apparatus where Aiden could see it. The boy didn’t make eye contact but he nodded, all the while humming his comfort song.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p41"
    }
  }, [_vm._v("The doc spoke again. “Okay, I’m going to put it in your ears. If you don’t like it, I’ll stop.” He gently put the ear pieces in Aiden’s ears and pressed the end of the stethoscope to his chest. Aiden finally went still. But he continued to hum his song.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p42"
    }
  }, [_vm._v("“This is about as good as it’s going to get,” Teri said. “But you’ll need to treat this like the most delicate surgery. Aiden hates being touched.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p43"
    }
  }, [_vm._v("The doctor nodded and went to work, moving slowly to cut away the jeans and extract the splinter without ever once touching Aiden with anything other than the cold, hard steel of his instruments. And yet, Dr. Crawford’s hands were gentle and competent and skilled. He made short work of it, and after he confirmed that Aiden was up-to-date on his tetanus shots, they were done with the scary stuff.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p44"
    }
  }, [_vm._v("She needed to get her son home as quickly as possible, so she gently took the stethoscope from Aiden’s ears.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p45"
    }
  }, [_vm._v("Big mistake.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p46"
    }
  }, [_vm._v("Aiden grabbed it back and started to howl and flail again.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p47"
    }
  }, [_vm._v("Damn.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p48"
    }
  }, [_vm._v("She did the unthinkable. She pried his fingers from the stethoscope and handed it back to the doctor. “Thanks, Doc. Sorry to rush, but I need to get him home, where we can gain some control. If you could just leave some instructions with Dana, I’ll call back for them.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p49"
    }
  }, [_vm._v("Time to leave Dodge in the dust. And since she’d already touched Aiden, she figured she might as well haul his butt out of the clinic. Judy had the car here so they could make a hasty departure.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p50"
    }
  }, [_vm._v("She lifted Aiden from the examining table. He’d weighed almost sixty pounds at his last checkup. Teri could still lift him, but when he arched his back and kicked her hard in the shin, she let him go. He didn’t hit the floor hard enough to hurt anything, but that didn’t matter. He immediately threw himself on his back and started banging his head on the floor.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p51"
    }
  }, [_vm._v("Damn. Damn. Damn. How could this be happening? Again.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p52"
    }
  }, [_vm._v("Teri had fallen in love with Aiden the moment they’d put him in her arms eight years ago. But when he howled like a torture victim, when he slammed his head against the floor like he wanted to break his brain, when he kicked and spat and lashed out at anyone and everyone, it still felt like a big, fat rejection.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p53"
    }
  }, [_vm._v("All of her efforts to calm him, to love him, to protect him were inevitably rebuffed. She didn’t know if she could keep this up for much longer. But then again, what else could she do? She couldn’t just fall out of love with her son.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p54"
    }
  }, [_vm._v("So she steeled herself like a Southern magnolia. Her son might be a disaster, but she loved him more than life. And she always had her good manners to cling to. She looked up at the doctor. “I’m so sorry he’s behaving like this. It’s not you. Trust me. Maybe we can stay here for a moment until he calms down?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p55"
    }
  }, [_vm._v("“It’s fine. Take whatever time you need. I’ll write out instructions for the care of the wound and leave them with Dana.” The kindness in Dr. Crawford’s eyes undid her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p56"
    }
  }, [_vm._v("But Aiden ruined the moment. He stopped howling, sat up, and glared at the new doctor before finally using his words. “You’re stupid,” he said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p57"
    }
  }, [_vm._v("The doc recoiled and departed so fast that Teri didn’t even have a chance to apologize a second time. Aiden had learned that word at school and had been repeating it to everyone he met. No doubt the other kids called him stupid all the time.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p58"
    }
  }, [_vm._v("But he wasn’t stupid.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p59"
    }
  }, [_vm._v("He was different.")]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration1"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p60"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p61"
    }
  }, [_vm._v("Aiden Summers was more direct in his assessment than any of the other ten patients Tom Crawford had seen today. But the consensus was the same: he was stupid, incompetent, and a Yankee.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p62"
    }
  }, [_vm._v("Who knew the Civil War was still a hot topic of debate in rural South Carolina?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p63"
    }
  }, [_vm._v("He stifled his frustration and headed to the examination cubicle where his next patient — Lillian Bray, a woman in her mid-sixties with a fat file — had been waiting. He thumbed through the paper records, annoyed by the lack of a modern computer-based information system. That would be changing. Federal legislation had mandated the transition to electronic records, and Tom was here to oversee that change because Doc Cooper was not interested.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p64"
    }
  }, [_vm._v("In addition to the computer update, Tom had been assigned to this clinic as part of the National Health Service Corps—a federal program that helps medically underserved areas attract physicians. The government would be repaying a portion of Tom’s medical school loans in return for his two-year commitment to the people of Last Chance. But it wasn’t just the money that had brought him here. Dr. Massey, his mentor, had insisted that a two-year stint in the Corps would make him a better doctor.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p65"
    }
  }, [_vm._v("Dr. Massey would tell him to suck up his frustration. The NHSC made a point of sending guys from Boston to rural towns in the South. That was part of the experience.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p66"
    }
  }, [_vm._v("He cleared his throat and shoved aside the privacy curtain for the next examination area. Before he could even introduce himself, a large woman with gray-blue hair greeted him with, “Who in blue blazes are you?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p67"
    }
  }, [_vm._v("“I’m Doctor Crawford. I’ll be taking over for Doctor Cooper.” Tom was so tired of saying this.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p68"
    }
  }, [_vm._v("“You will not.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p69"
    }
  }, [_vm._v("He ignored her outburst. “What seems to be the problem today?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p70"
    }
  }, [_vm._v("She pouted. Evidently she expected him to leave. But he was a patient man. He waited.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p71"
    }
  }, [_vm._v("A minute passed in charged silence before he said, “If you don’t have any medical issues, I guess I’ll move on to the next patient.” He started to turn away.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p72"
    }
  }, [_vm._v("“No, wait. There’s no need to be rude, young man,” Mrs. Bray said. “That may be the way folks up north behave. But down here we value manners.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p73"
    }
  }, [_vm._v("He ground his back teeth and gave her his best bedside smile. What the heck had happened to Southern hospitality?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p74"
    }
  }, [_vm._v("After another long silence, Mrs. Bray said, “It’s my arthritis. It’s acting up again.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p75"
    }
  }, [_vm._v("He checked her file and found nothing that indicated any kind of arthritis. She had high cholesterol and blood pressure. Her BMI was unhealthy. He wouldn’t be surprised if she had some arthritis at her age, but she’d never seen Dr. Cooper about it. At least not according to the records.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p76"
    }
  }, [_vm._v("“I just need some pills,” she said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p77"
    }
  }, [_vm._v("“What kind of pills?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p78"
    }
  }, [_vm._v("“You know, the pills that Doc Cooper gives me.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p79"
    }
  }, [_vm._v("He immediately went on guard. “What pills are those?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p80"
    }
  }, [_vm._v("“You know, the little white ones. He gets them from his special cupboard in his office. I’m sure you’ll find the information in my file. I’ve had rheumatoid arthritis in my hands for years.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p81"
    }
  }, [_vm._v("What was going on here? He didn’t like this one bit. But he tried to mask his concern from the patient. Instead he asked the woman a series of questions and made an examination of her hands, where she said she felt the most pain. He found no evidence of joint damage or trauma.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p82"
    }
  }, [_vm._v("Was Mrs. Bray one of those attention-seeking patients? Or was the beloved Doc Cooper handing out painkillers to bored little old ladies?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p83"
    }
  }, [_vm._v("He sat on the stool and made eye contact. “Mrs. Bray, I can’t give you pills because Doc Cooper didn’t put any information in your file about what kind of medicine he was giving you. I can prescribe some extra-strength ibuprofen. But since I also don’t see any indication in your file that you’ve been evaluated by a rheumatologist, I think it might a good idea for you to see a specialist. I can—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p84"
    }
  }, [_vm._v("The old lady’s eyes bugged out as she interrupted. “I don’t have time to run up to Columbia to see specialists. That’s why you’re here, young man. Now, I’d like my pills.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p85"
    }
  }, [_vm._v("“I’m very sorry, but I don’t dispense pills. And I don’t know what Doctor Cooper was giving you. He’s made no notation in the files. So if you’re having problems with your hands, I think we need to send you to a specialist. I can have Dana see about getting you transportation up to Columbia or the nearest regional center. But if you’re having pain in your legs or knees, that could definitely be because of your weight. I think we—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p86"
    }
  }, [_vm._v("“I didn’t come here to talk about my weight.” Mrs. Bray climbed down from the examining table and picked up her purse. “I’m leaving.” She put her nose in the air and marched from the examining room out to the reception area, where she told Dana, in a voice loud enough for Tom to hear, exactly what she thought of “that Yankee doctor.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p87"
    }
  }, [_vm._v("It didn’t make Tom feel any better to hear Dana agreeing with every word the old lady said.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-506a9e08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s005-Chapter-001.vue
// module id = 72
// module chunks = 0